<template>
    <v-row id="static-page__sections">
        <v-col cols="12">
            <h2 class="mt-4">Content Sections</h2>
        </v-col>

        <v-col
            cols="12"
            v-for="section in currentStaticPage.sections"
            :key="section.id"
        >
            <v-textarea
                data-testid="static-page-section-content-textarea"
                class="static-page-section-content-textarea"
                filled
                :label="section.label"
                v-model.trim="section.content"
                v-if="section.type === 'textarea'"
                clearable
            />

            <h3 class="mb-2" v-if="section.type === 'wysiwyg'">
                {{ section.label }}
            </h3>

            <div class="froala-container">
                <froala-wrapper
                    :section="section"
                    :froalaConfig="froalaConfig"
                    :launchFroala="launchFroala"
                />
            </div>

            <div class="froala-container">
                <app-input
                    data-testid="static-page-section-label-input"
                    class="static-page-section-label-input"
                    :type="'text'"
                    :label="section.label"
                    v-model.trim="section.content"
                    v-if="section.type === 'text'"
                />
            </div>
            <div v-if="section.type === 'image'" class="image-input">
                <h3>{{ section.label }}</h3>
                <div v-if="JSON.parse(section.content) && JSON.parse(section.content).id" class="has-image">
                    <v-img
                        :src="imageBasePath + JSON.parse(section.content).url"
                        aspect-ratio="1"
                    >
                        <v-row
                            class="fill-height ma-0"
                            slot="placeholder"
                            align="center"
                            justify="center"
                        >
                            <v-progress-circular indeterminate color="grey" />
                        </v-row>
                    </v-img>
                    <v-btn
                      data-testid="static-page-section-delete-btn"
                      class="static-page-section-delete-btn my-3"
                      @click="openDelete(section)"
                      color="error"
                      small
                      block
                    >
                      Delete
                    </v-btn>
                </div>
                <div v-else class="no-image">
                    <add-photo
                        data-testid="static-page-section-add-photo-btn"
                        class="static-page-section-add-photo-btn"
                        dispatchMethod="uploadStaticPageImage"
                        :additionalData="{ ident: section.ident }"
                    />
                </div>
            </div>
        </v-col>

        <delete-modal
            v-model="modal"
            @delete="deletePhoto"
            :itemType="'photo'"
            :advisory="advisory"
        />
    </v-row>
</template>

<script>
import AddPhoto from "@/components/AddPhoto.vue";
import AppInput from "@/components/global/AppInput";
import DeleteModal from "@/components/DeleteModal.vue";
import FroalaWrapper from "@/views/static-page/partials/FroalaWrapper.vue";
import { genericAdvisory } from "@/helpers/warning-advisory-text";

export default {
  props: {
    launchFroala: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      advisory: genericAdvisory,
      imageBasePath: process.env.VUE_APP_PHOTO_BASE_PATH + "/",
      loading: false,
      modal: false,
      selectedSection: ""
    };
  },

  computed: {
    currentStaticPage: {
      get() {
        return this.$store.state.staticPage.currentStaticPage;
      },
      set(newValue) {
        this.$store.commit("setCurrentStaticPageData", newValue);
      }
    },
    froalaConfig() {
      return {
        ...this.$store.state.app.froalaConfig,
        theme: this.$vuetify.theme.dark ? "dark" : null,
        requestHeaders: {
          Authorization: this.$store.state.auth.access_token
        }
      };
    }
  },

  methods: {
    openDelete(section) {
      this.selectedSection = section;
      this.modal = true;
    },

    async deletePhoto() {
      this.loading = true;
      this.$store.dispatch("deleteStaticPageImage", {
        imageId: JSON.parse(this.selectedSection.content).id,
        staticPageId: this.currentStaticPage.id,
        ident: this.selectedSection.ident
      }).then(() => {
        this.loading = false;
        this.selectedSection = "";
        this.modal = false;
        this.$store.dispatch("getStaticPage", this.currentStaticPage.id);
      });
    }
  },

  components: {
    AddPhoto,
    AppInput,
    DeleteModal,
    FroalaWrapper
  }
};
</script>

<style lang="scss" scoped>
    .image-input {
        h3 {
            margin-bottom: 15px;
        }

        .no-image {
            margin-bottom: 15px;
            max-width: 150px;
        }

        .has-image {
            max-width: 300px;
        }

        .froala-container {
            position: relative;
            overflow: hidden;
            padding-top: 56.25%;
        }
    }
</style>
